import type { MarketDetails } from '#app/store/slices/configuration/marketSlice'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

export function deriveMarketLanguage(configuration: TruckConfiguration, marketDetails: MarketDetails | undefined): string | undefined {
  const orderLanguage = configuration.apiConfiguration.orderLanguage
  if (!marketDetails || orderLanguage) {
    return orderLanguage
  }

  const marketLanguageId = configuration.apiConfiguration.language
  const marketLanguages = marketDetails.languages ?? []

  const languageByLanguageId = marketLanguages.find((language) => language.languageId === marketLanguageId)

  if (languageByLanguageId) {
    return languageByLanguageId.languageCode
  }

  return marketLanguages[0]?.languageCode
}
